<template>
  <v-flex>
    <v-btn
      color="accent"
      block
      large
      class="mapCardWrap"
      @click="vuexBetriebe(leistung.gewerk.defaultleistung_id)"
      :loading="busy"
    >Ausweiten auf {{ leistung.gewerk.name }} </v-btn>
  </v-flex>
</template>

<script>
export default {
  props: ['leistung'],
  components: {},
  data: () => ({
    busy: false
  }),
  computed: {},
  mounted: function () {},

  methods: {
    async vuexBetriebe (id) {
      this.busy = true
      var payload = {
        leistung: id,
        standort: this.$store.state.suche.stadt,
        erweitert: true
      }
      // console.log(payload)
      await this.$store.dispatch('fetchBetriebe', payload)

      // var gaevent = this.Leistung

      // this.$ga.event({
      //   eventCategory: 'Betriebssuche',
      //   eventAction: 'Suche ausgeweitet',
      //   eventValue: gaevent
      // })

      this.busy = false
      this.$emit('busy', false)
    }
  }
}
</script>
<style>
</style>